<template>
  <div>
    <span class="erro" v-if="validacao">Por favor, selecione um email para receber as alterações</span>
    <select
      id="emailCliente"
      name="email"
      class="form-control pt-1 mb-5 fadeW"
      style="height: 30px; width: 500px"
      v-if="!loading"
      @change="emitir()"
      v-model="selecionado"
    >
      <option value>Selecione o e-mail que deseja receber as notificações</option>
      <option v-for="(email, index) in emails" :key="index" :value="email">{{ email }}</option>
    </select>
    <div class="text-center" v-else>
      <div class="spinner-border text-primary text-center" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    emails: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    validacao: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      selecionado: ""
    };
  },
  methods: {
    emitir() {
      this.$emit("emailSelecionado", this.selecionado);
    }
  }
};
</script>

<style scoped>
.erro {
  color: red;
}
</style>